export var version = "3.10.4";
//# sourceMappingURL=version.js.map